import { useMatch } from 'react-router-dom';
import { useEntityName } from '@/hooks/useEntityName';
import { useMetricName } from '@/hooks/useMetricName';

export const useEntityPreviewHeader = () => {
  const isDataLockerPage = !!useMatch('/:locale/data-locker/*');
  const isSquadPage = !!useMatch('/:locale/team/:teamId/squad/*');
  const entityName = useEntityName();
  const metricName = useMetricName();

  // Note that localisation here does not currently support if metric name should precede entity
  if (isDataLockerPage || isSquadPage) {
    return [entityName, metricName].filter(Boolean).join(' - ') || undefined;
  }
  return metricName || undefined;
};
